import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/am-i-a-candidate-for-tms")({
  beforeLoad: () => {
    throw redirect({ to: "/am-i-a-candidate" });
  },
});
